import { emulatorScreen, mobileScreen } from "../../../../utils/styleUtils";
var isSafari =
  /constructor/i.test(window.HTMLElement) ||
  (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(
    !window["safari"] ||
      (typeof safari !== "undefined" && window["safari"].pushNotification)
  );

const styles = (theme) => ({
  verticalLinesContainer: {
    position: "absolute",
    top: "-52px",
    left: "225px",
    [emulatorScreen(theme)]: {
      top: "-35px",
      left: "150px",
    },
    [mobileScreen(theme)]: {
      top: "-25px",
      left: "100px",
    },
  },

  graphLines: {
    borderLeft: "5px solid #565656",
    borderBottom: "5px solid #565656",
    height: "330px",
    width: "460px",
    position: "relative",
    [emulatorScreen(theme)]: {
      width: "290px",
      height: "210px",
      borderWidth: "3px",
    },
    [mobileScreen(theme)]: {
      width: "200px",
      height: "150px",
      borderWidth: "3px",
    },
  },

  graphYLable: {
    height: "18px",
    position: "absolute",
    top: "7px",
    left: "-90px",
    [emulatorScreen(theme)]: {
      height: "12px",
      left: "-60px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      left: "-50px",
    },
  },

  graphXLable: {
    height: "18px",
    position: "absolute",
    bottom: "-35px",
    right: "5px",
    [emulatorScreen(theme)]: {
      height: "12px",
      bottom: "-25px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      bottom: "-22px",
    },
  },

  dragLineMessage: {
    height: "130px",
    position: "absolute",
    right: "-20px",
    top: "80px",
    [emulatorScreen(theme)]: {
      height: "90px",
      right: "-25px",
      top: "50px",
    },
    [mobileScreen(theme)]: {
      top: "25px",
      right: "-25px",
      height: "75px",
    },
  },

  questionMark: {
    width: "150px",
    [emulatorScreen(theme)]: {
      width: "95px",
    },
    [mobileScreen(theme)]: {
      width: "85px",
    },
  },

  arrows: {
    position: "absolute",
    height: "30px",
    top: "185px",
    left: "-50px",
    [emulatorScreen(theme)]: {
      top: "117px",
      left: "12px",
      height: "18px",
    },
    [mobileScreen(theme)]: {
      top: "84px",
      left: "8px",
      height: "10px",
    },
  },

  defaultLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    backgroundColor: "#003e4c",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  correctLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLine: {
    display: "flex",
    justifyContent: "center",
    height: "400px",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLineContainer: {
    display: "flex",
    justifyContent: "center",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    top: "28px",
    left: "-68px",
    height: "0",
    position: "absolute",
    // [emulatorScreen(theme)]: {
    //   height: "260px",
    //   width: "5px",
    // },
    // [mobileScreen(theme)]: {
    //   height: "190px",
    //   width: "4px"
    // },
  },

  fadedDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003E4C",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#003E4C",
    top: "120px",
    color: "blue",
    [emulatorScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
  },

  correctDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003e4c",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#CACDCE",
    color: "blue",
    zindex: 100,
    // border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
  },

  draggableDot: {
    transform: "rotate(45deg)",
    borderRadius: "50%",
    padding: "10px",
    color: "blue",
    border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
  },

  internationalContainerMajor: {
    justifyContent: "center",
    position: "relative",
    display: "flex",

    [emulatorScreen(theme)]: {
      justifyContent: "start",
    },
    [mobileScreen(theme)]: {
      justifyContent: "start",
    },
  },

  internationalContainerChild: {
    position: "relative",
    display: "flex",
    height: 400,
    width: 400,
    [emulatorScreen(theme)]: {
      height: 270,
      width: 270,
    },
    [mobileScreen(theme)]: {
      height: 270,
      width: 270,
    },
  },

  disabledInternationalContainerChild: {
    position: "relative",
    display: "flex",
    height: 400,
    width: 400,
    pointerEvents: "none",
    opacity: 0.5,
    [emulatorScreen(theme)]: {
      height: 270,
      width: 270,
    },
    [mobileScreen(theme)]: {
      height: 270,
      width: 270,
    },
  },

  qdWhite: {
    height: "27%",
    top: 195,
    position: "absolute",
    marginLeft: "82.5%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      top: 133,
    },
    [mobileScreen(theme)]: {
      top: 133,
    },
  },

  qoWhite: {
    height: "27%",
    top: 195,
    position: "absolute",
    left: 286,
    paddingTop: "15%",
    zIndex: 1,
    [emulatorScreen(theme)]: {
      top: 132,
      left: 193,
    },
    [mobileScreen(theme)]: {
      top: 132,
      left: 193,
    },
  },

  qsWhite: {
    height: "27%",
    top: 195,
    position: "absolute",
    marginLeft: "61%",
    paddingTop: "15%",
    zIndex: 1,
    [emulatorScreen(theme)]: {
      top: 132,
      marginLeft: "60.7%",
    },
    [mobileScreen(theme)]: {
      top: 132,
      marginLeft: "60.7%",
    },
  },

  poWhite: {
    position: "absolute",
    top: 179,
    width: "55%",
    left: 77,
    [emulatorScreen(theme)]: {
      top: 120,
      left: 51,
    },
    [mobileScreen(theme)]: {
      top: 120,
      left: 51,
    },
  },

  tariffLine: {
    height: "15.8%",
    position: "absolute",
    zIndex: 2,
    marginLeft: isSafari ? "22.5%" : "43%",
    paddingTop: "30%",
    [emulatorScreen(theme)]: {
      marginLeft: "0%",
      paddingTop: "28.3%",
    },
    [mobileScreen(theme)]: {
      marginLeft: "0%",
      paddingTop: "28.3%",
    },
  },

  // line 2
  vertWhiteHalf: {
    height: "8%",
    top: 195,
    right: 89,
    position: "absolute",
    zIndex: 1,
    width: 22,
    [emulatorScreen(theme)]: {
      top: 131,
      right: 56.5,
    },
    [mobileScreen(theme)]: {
      top: 133,
      right: 57,
    },
  },

  // line 3
  line3: {
    height: "8%",
    top: 224,
    right: 131.5,
    position: "absolute",
    zIndex: 1,
    width: 22,
    [emulatorScreen(theme)]: {
      top: 153,
      right: 85.5,
    },
    [mobileScreen(theme)]: {
      top: 150,
      right: 85.5,
    },
  },

  // line 4
  vertWhiteHalf1: {
    height: "8%",
    top: 224,
    right: 89,
    position: "absolute",
    zIndex: 1,
    width: 22,
    [emulatorScreen(theme)]: {
      top: 153,
      right: 56.5,
    },
    [mobileScreen(theme)]: {
      top: 150,
      right: 57,
    },
  },

  // line5
  line5: {
    height: "8%",
    top: 224,
    right: 46,
    position: "absolute",
    zIndex: 1,
    width: 22,
    [emulatorScreen(theme)]: {
      top: 153,
      right: 26.5,
    },
    [mobileScreen(theme)]: {
      top: 151,
      right: 27.5,
    },
  },

  horizontalBlue: {
    position: "absolute",
    top: 179,
    width: "46%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 120.15,
      width: "46.5%",
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 120.15,
      width: "46.5%",
      left: 75,
    },
  },

  verticle2HalfBlue: {
    height: "17.7%",
    top: 200,
    position: "absolute",
    marginLeft: "61%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      height: "17%",
      top: 136,
      marginLeft: "61.05%",
    },
    [mobileScreen(theme)]: {
      height: "17%",
      top: 136,
      marginLeft: "61%",
    },
  },

  verticleBlueHalf: {
    height: "7%",
    top: 195,
    right: 98,
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "17%",
      top: 130,
      left: 193.5,
      right: "0%",
    },
    [mobileScreen(theme)]: {
      height: "17%",
      top: 130,
      left: 193.5,
      right: "0%",
    },
  },

  verticle1HalfBlue: {
    height: "18%",
    top: 261,
    position: "absolute",
    left: 287,
    [emulatorScreen(theme)]: {
      top: 175,
      left: 193,
    },
    [mobileScreen(theme)]: {
      top: 175,
      left: 193,
    },
  },

  vertRedHalf: {
    height: "7%",
    top: 193,
    right: 98,
    position: "absolute",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      top: 128,
      right: "24.6%",
    },
  },

  verticle3HalfBlue: {
    height: "27%",
    top: 195,
    position: "absolute",
    marginLeft: "82.5%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      height: "26%",
      top: 135,
      marginLeft: "82.7%",
    },
    [mobileScreen(theme)]: {
      height: "26%",
      top: 135,
    },
  },

  verticle2HalfRed: {
    position: "absolute",
    top: 260,
    width: 4.5,
    left: 297.5,
    [emulatorScreen(theme)]: {
      height: "18%",
      top: 176,
      left: 200,
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 176,
      left: 200,
    },
  },

  verticle3HalfRed: {
    height: "17%",
    top: 201,
    position: "absolute",
    marginLeft: "85.4%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      top: 136,
      marginLeft: "85.5%",
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 135,
      marginLeft: "85.6%",
    },
  },

  verticle1HalfRed: {
    height: 69,
    top: 200,
    position: "absolute",
    marginLeft: "63.6%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      height: 46,
      top: 136,
      marginLeft: "63.7%",
    },
    [mobileScreen(theme)]: {
      height: 46,
      top: 136,
      marginLeft: "63.6%",
    },
  },

  verticleGreenHalf: {
    height: "7%",
    top: 193,
    right: 98,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 126,
      right: 65.65,
    },
    [mobileScreen(theme)]: {
      top: 126,
      right: 65.65,
    },
  },

  horizontalRedLine: {
    height: "1%",
    position: "absolute",
    top: 189,
    width: "46%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 127,
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 127,
      left: 75,
    },
  },

  horizontalGreenLine: {
    position: "absolute",
    top: 188,
    width: "48%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 127,
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 127,
      left: 75,
    },
  },

  shape1Major: {
    width: 373,
    overflow: "hidden",
    top: 41.5,
    left: 116,
    position: "absolute",
    zIndex: 3,
    height: 145,
    [emulatorScreen(theme)]: {
      width: 263,
      top: 21.5,
      left: 74,
      height: 104,
    },
    [mobileScreen(theme)]: {
      width: 263,
      top: 21.5,
      left: 74,
      height: 104,
    },
  },

  shape1: {
    height: 142,
    width: 373,
    marginTop: 4,
    [emulatorScreen(theme)]: {
      height: 142,
      width: 373,
      marginTop: 4,
    },
    [mobileScreen(theme)]: {
      height: 142,
      width: 373,
      marginTop: 4,
    },
  },

  shape2Major: {
    width: 183,
    overflow: "hidden",
    top: 45.5,
    left: 111,
    position: "absolute",
    zIndex: 2,
    [emulatorScreen(theme)]: {
      width: 122,
      top: 30.5,
      left: 75,
    },
    [mobileScreen(theme)]: {
      width: 122,
      top: 30.5,
      left: 75,
    },
  },

  shape2: {
    height: 136.5,
    width: 182.5,
    marginTop: 7,
    [emulatorScreen(theme)]: {
      height: 92,
      width: "100%",
      marginTop: 5,
    },
    [mobileScreen(theme)]: {
      height: 92.5,
      width: 123.5,
      marginTop: 4,
    },
  },

  shape5Major: {
    width: 180,
    height: 28,
    overflow: "hidden",
    top: 193,
    left: 111,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 123,
      height: 21,
      top: 129.5,
      left: 75,
    },
    [mobileScreen(theme)]: {
      width: 122,
      height: 20.5,
      top: 129.5,
      left: 75,
    },
  },

  shape5: {
    height: 27,
    width: 180,
    clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
    shapeOutside: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      clipPath: "polygon(0 0, 100% 0, 77% 100%, 0% 100%)",
      height: "100%",
      width: "100%",
    },
    [mobileScreen(theme)]: {
      height: 43,
      width: 123,
      clipPath: "polygon(0 0, 100% 0, 54% 100%, 0% 100%)",
      shapeOutside: "polygon(0 0, 100% 0, 54% 100%, 0% 100%)",
    },
  },

  shape5LowerMajor: {
    width: 136,
    height: 29.3,
    overflow: "hidden",
    top: 226,
    left: 111,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 90,
      height: 18.3,
      top: 154,
      left: 75,
    },
    [mobileScreen(theme)]: {
      width: 90,
      height: 17.3,
      top: 154,
      left: 75,
    },
  },

  shape5Lower: {
    height: "100%",
    width: "100%",
    clipPath: "polygon(0 0, 100% 0, 72% 100%, 0% 100%)",
    shapeOutside: "polygon(0 0, 100% 0, 72% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      clipPath: "polygon(0 0, 100% 0, 73% 100%, 0% 100%)",
      height: "100%",
      width: "100%",
    },
    [mobileScreen(theme)]: {
      clipPath: "polygon(0 0, 100% 0,75% 100%, 0% 100%)",
      shapeOutside: "polygon(0 0, 100% 0, 75% 100%, 0% 100%)",
    },
  },

  shape8Major: {
    width: 100,
    height: 69,
    overflow: "hidden",
    top: 260.5,
    left: 111,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 61,
      height: 46,
      top: 176,
      left: 75,
    },
    [mobileScreen(theme)]: {
      width: 60,
      height: 46,
      top: 176,
      left: 75,
    },
  },

  shape8: {
    height: 68,
    width: 91,
    [emulatorScreen(theme)]: {
      height: 46,
      width: "100%",
    },
    [mobileScreen(theme)]: {
      height: 46,
      width: 60,
    },
  },

  shape9Major: {
    width: 137.5,
    height: 70,
    overflow: "hidden",
    top: 260.5,
    left: 118,
    position: "absolute",
    clipPath: "polygon(68% 0, 100% 0, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(68% 0, 100% 0, 100% 100%, 0% 100%)",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 95,
      height: 49,
      top: 176,
      left: 78,
    },
    [mobileScreen(theme)]: {
      width: 92,
      height: 48,
      top: 175.5,
      left: 80,
    },
  },

  shape9: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: "97%",
      width: "99.15%",
    },
    [mobileScreen(theme)]: {
      height: "100%",
      width: "100%",
    },
  },

  shape10Major: {
    width: 39.3,
    height: 70,
    overflow: "hidden",
    top: 260.5,
    left: 259,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 25.7,
      height: 47.5,
      top: 176,
      left: 175,
    },
    [mobileScreen(theme)]: {
      width: 26.5,
      height: 48,
      top: 175.5,
      left: 174.5,
    },
  },

  shape10: {
    height: 70,
    width: 82,
    [emulatorScreen(theme)]: {
      height: "100%",
      width: 58,
    },
    [mobileScreen(theme)]: {
      height: "100%",
      width: '100%'
    },
  },

  shape6Major: {
    width: 33.5,
    height: 25.5,
    overflow: "hidden",
    top: 194.5,
    left: 265,
    position: "absolute",
    zIndex: 3,
    clipPath: "polygon(100% 1px, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(100% 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 23,
      height: 19,
      top: 131,
      left: 178.5,
    },
    [mobileScreen(theme)]: {
      width: 26,
      height: 18,
      top: 132,
      left: 175,
    },
  },

  shape6: {
    height: 61,
    width: 82,
    [emulatorScreen(theme)]: {
      height: 42,
      width: 54,
    },
    [mobileScreen(theme)]: {
      height: 42,
      width: 54,
    },
  },

  shape6LowerMajor: {
    width: 39,
    height: 26.5,
    overflow: "hidden",
    top: 228,
    left: 217,
    position: "absolute",
    zIndex: 3,
    clipPath: "polygon(100% 0, 100% 0, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(100% 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 24,
      height: 18,
      top: 154,
      left: 148,
    },
    [mobileScreen(theme)]: {
      width: 23,
      height: 16.5,
      top: 155,
      left: 149,
    },
  },

  shape6Lower: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: 42,
      width: 54,
    },
    [mobileScreen(theme)]: {
      height: 42,
      width: 54,
    },
  },

  shape6LowerMajor2: {
    width: 39,
    height: 28.5,
    overflow: "hidden",
    top: 226,
    left: 259.5,
    position: "absolute",
    zIndex: 3,
    clipPath: "polygon(0 0, 100% 0%, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(100% 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 26.3,
      height: 18,
      top: 154,
      left: 175,
    },
    [mobileScreen(theme)]: {
      width: 26,
      height: 17.5,
      top: 154,
      left: 175,
    },
  },
  shape6Lower2: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: 42,
      width: "100%",
    },
    [mobileScreen(theme)]: {
      height: 42,
      width: 54,
    },
  },

  shape7Major: {
    height: 25.5,
    width: 34.5,
    overflow: "hidden",
    top: 195,
    left: 302,
    position: "absolute",
    zIndex: 3,
    clipPath: "polygon(100% 100%, 0 0, 0 100%)",
    shapeOutside: "polygon(100% 100%, 0 0, 0 100%)",
    [emulatorScreen(theme)]: {
      height: 19.5,
      width: 25.5,
      top: 131,
      left: "75.35%",
    },
    [mobileScreen(theme)]: {
      height: 18.5,
      width: 25.5,
      top: 131.5,
      left: "75.2%",
    },
  },

  shape7: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: 41.5,
      width: 55.5,
    },
    [mobileScreen(theme)]: {
      height: 41.5,
      width: 55.5,
    },
  },

  shape7LowerMajor: {
    height: 29,
    width: 39.5,
    overflow: "hidden",
    top: 226,
    left: 302,
    position: "absolute",
    zIndex: 3,
    clipPath: "polygon(0 0, 100% 0%, 100% 100%, 0% 100%)",

    shapeOutside: "polygon(0 0, 50% 0, 100% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      height: 18,
      width: 28,
      top: 154,
      left: "75.35%",
    },
    [mobileScreen(theme)]: {
      height: 17.5,
      width: 27,
      top: 154,
      left: "75.35%",
    },
  },

  shape7Lower: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: 41.5,
      width: 55.5,
    },
    [mobileScreen(theme)]: {
      height: 41.5,
      width: 55.5,
    },
  },

  shape7LowerMajor2: {
    height: 28,
    width: 37,
    overflow: "hidden",
    top: 227,
    left: 345,
    position: "absolute",
    zIndex: 3,
    clipPath: "polygon(0 0, 0 0, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(0 0, 50% 0, 100% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      height: 18,
      width: 24,
      top: 154,
      left: "86.5%",
    },
    [mobileScreen(theme)]: {
      height: 18.5,
      width: 24.5,
      top: 153,
      left: "86.35%",
    },
  },

  shape7Lower2: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: 41.5,
      width: "100%",
    },
    [mobileScreen(theme)]: {
      height: 41.5,
      width: 55.5,
    },
  },

  shape11Major: {
    width: 40.5,
    height: 70,
    overflow: "hidden",
    top: 260.5,
    left: 302,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 28.5,
      height: 48,
      top: 176,
      left: "75.3%",
    },
    [mobileScreen(theme)]: {
      width: 28,
      height: 48,
      top: 175.5,
      left: "75.3%",
    },
  },

  shape11: {
    height: 70,
    width: 87,
    [emulatorScreen(theme)]: {
      height: "100%",
      width: "97.4%",
    },
    [mobileScreen(theme)]: {
      height: '100%',
      width: "100%",
    },
  },

  shape14Major: {
    width: 184.5,
    height: 166.5,
    overflow: "hidden",
    top: 53,
    left: 305,
    position: "absolute",
    zIndex: 2,
    clipPath: "polygon(0% 82%, 100% 0%, 100% 100%, 23% 100%)",
    shapeOutside: "polygon(0% 82%, 100% 0%, 100% 100%, 23% 100%)",
    [emulatorScreen(theme)]: {
      width: 123,
      height: 114,
      top: 36,
      left: 207,
      clipPath: "polygon(0% 81%, 100% 0%, 100% 100%, 23% 100%)",
    },
    [mobileScreen(theme)]: {
      width: 122.5,
      height: 114,
      top: 36,
      left: 207,
      clipPath: "polygon(0% 81%, 100% 0%, 100% 100%, 23% 100%)",
    },
  },

  shape14: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: 143,
      width: 129.5,
    },
    [mobileScreen(theme)]: {
      height: 143,
      width: 129.5,
    },
  },

  shape14LowerMajor: {
    width: 135,
    height: 28,
    overflow: "hidden",
    top: 226,
    left: 355,
    position: "absolute",
    zIndex: 2,
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 28% 100%)",
    shapeOutside: "polygon(0 0, 100% 0, 100% 100%, 28% 100%)",
    [emulatorScreen(theme)]: {
      width: 91,
      height: 17.5,
      top: 154,
      left: 239,
    },
    [mobileScreen(theme)]: {
      width: 90,
      height: 17,
      top: 154.5,
      left: 240,
    },
  },

  shape14Lower: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: 143,
      width: 129.5,
    },
    [mobileScreen(theme)]: {
      height: 143,
      width: 129.5,
    },
  },

  shape12Major: {
    width: 137.5,
    height: 69.5,
    overflow: "hidden",
    top: 261,
    left: 346,
    position: "absolute",
    zIndex: 2,
    clipPath: "polygon(0 0, 33% 0, 100% 100%, 0% 100%)",
    shapeOutside: "polygon(0 0, 33% 0, 100% 100%, 0% 100%)",
    [emulatorScreen(theme)]: {
      width: 94,
      height: 48,
      top: 176,
      left: 234,
    },
    [mobileScreen(theme)]: {
    clipPath: "polygon(0 0, 31% 0, 100% 100%, 0% 100%)",
      width: 93.5,
      height: 48,
      top: 175.5,
      left: 234,
    },
  },

  shape12: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      height: 47.5,
      width: "98%",
    },
    [mobileScreen(theme)]: {
      height: '100%',
      width: "100%",
    },
  },

  shape13Major: {
    width: 89,
    height: 67,
    overflow: "hidden",
    top: 260.5,
    left: 400,
    position: "absolute",
    zIndex: 2,
    clipPath: "polygon(100% 0, 0 0, 100% 100%)",
    shapeOutside: "polygon(100% 0, 0 0, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 59,
      height: 44,
      top: 175.9,
      left: 271,
    },
    [mobileScreen(theme)]: {
      width: 60,
      height: 45,
      top: 175.5,
      left: 270,
    },
  },

  shape13: {
    height: 67,
    width: 89,
    [emulatorScreen(theme)]: {
      height: 44.5,
      width: 59,
    },
    [mobileScreen(theme)]: {
      height: '100%',
      width: '100%'
    },
  },
});
export default styles;
